import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getEditionNavigationBannerKind } from '../../services/editionNavUi';

import './EditionNavBanner.scss';

const EditionNavBanner = () => {
    const { t } = useTranslation();
    const user = useSelector((state) => state.auth?.user);
    const selectedId = useSelector((state) => state.editionNavigation?.selectedEditionId);

    const can_read_editions = Boolean(
        user?.abilities?.superadmin
        || (typeof user?.can === 'function' && user.can('read', 'editions'))
    );

    const kind = useSelector((state) => getEditionNavigationBannerKind(state));

    const instanceLabel = (user?.tkt_instance?.name || '').trim()
        || t('editions.banner.instance_fallback');

    const message = useMemo(() => {
        if (!kind || !selectedId) {
            return null;
        }
        if (kind === 'past') {
            return t('editions.banner.past', {
                instanceLabel,
                editionId: String(selectedId),
            });
        }
        return t('editions.banner.future');
    }, [kind, selectedId, instanceLabel, t]);

    if (!can_read_editions || !kind || !message) {
        return null;
    }

    const alertClass = kind === 'past' ? 'alert alert-warning' : 'alert alert-info';

    return (
        <div className="EditionNavBanner noPrint">
            <div className={alertClass} role="status">
                <p className="EditionNavBanner__text">{message}</p>
            </div>
        </div>
    );
};

export default EditionNavBanner;
